import { render, staticRenderFns } from "./CoordinatorsForm.vue?vue&type=template&id=cccedab0&scoped=true&"
import script from "./CoordinatorsForm.vue?vue&type=script&lang=js&"
export * from "./CoordinatorsForm.vue?vue&type=script&lang=js&"
import style0 from "./CoordinatorsForm.vue?vue&type=style&index=0&id=cccedab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cccedab0",
  null
  
)

export default component.exports